"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DomainError extends Error {
    /**
     * Represents a violation of business rules that was unexpected or not allowed.
     */
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.DomainError = DomainError;
//# sourceMappingURL=DomainError.js.map